import { render } from "./votingStats.vue?vue&type=template&id=05573e93&scoped=true"
import script from "./votingStats.vue?vue&type=script&lang=js"
export * from "./votingStats.vue?vue&type=script&lang=js"

import "./votingStats.vue?vue&type=style&index=0&id=05573e93&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05573e93"]])

export default __exports__